var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shouldShowChatbot),expression:"shouldShowChatbot"}],attrs:{"id":"container-ms-DocumentacaoInterativaChat-9775"}})
}
var staticRenderFns = []

export { render, staticRenderFns }